export default "__VITE_ASSET__Dk9CxEX5__"